import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { LoadingDots } from "../Components/LoadingDots";
import accountService from "../Services/accountService";
import incomeService from "../Services/incomeService";
import incomesHeadService from "../Services/incomeHeadService";
import customerService from "../Services/customerService";
import { FaArrowLeft } from "react-icons/fa6";
import moment from "moment";
import orderService from "../Services/orderService";
import supplierService from "../Services/supplierService";
import purchaseService from "../Services/purchaseService";
import Dropdown from "../Components/Dropdown";

const AddSupplierPayments = () => {
  const navigate = useNavigate();
  const [responseError, setResponseError] = useState("");
  const [accounts, setAccounts] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [method, setMethod] = useState("");
  const [data, setData] = useState({
    supplier: "",
    amount: "",
    account: "",
    note: "",
    date: "",
    voucher: "",
    order_id: "",
    method: "",
  });

  const [errors, setErrors] = useState({
    supplier: false,
    amount: false,
    account: false,
    note: false,
    date: false,
    voucher: false,
    order_id: false,
    method: false,
  });

  const [regex, setRegex] = useState({
    supplier: /.{1,50}$/,
    amount: /.{1,50}$/,
    account: /.{1,50}$/,
    note: /.{1,50}$/,
    date: /.{1,50}$/,
    voucher: /.{1,50}$/,
    order_id: /^[0-9]*$/,
    method: /.{1,20}$/,
  });

  useEffect(() => {
    supplierService.fetchAll().then((res) => {
      setSuppliers(res.suppliers);
    });
    accountService.fetchAllActiveAccounts().then((res) => {
      setAccounts(res.accounts);
    });
  }, []);

  const handleChange = async (v, n) => {
    if (n === "date" && v > moment().format("YYYY-MM-DD")) {
      toast.error("Cannot select future date", { id: "1" });
      return;
    }
    if (n === "amount" && v < 0) {
      return;
    }

    setResponseError("");
    setData((d) => ({ ...d, [n]: v }));

    if (v.length > 0) {
      setErrors((prevState) => ({ ...prevState, [n]: false }));
    }

    if (n === "supplier") {
      try {
        const res = await purchaseService.fetchSupplierUnpaid(v);
        if (res?.purchase) {
          setOrders(res.purchase);
        }
      } catch (error) {
        console.error("Error fetching supplier orders:", error);
        toast.error("Failed to load orders.");
      }
    }
  };

  // const handleSubmit = () => {
  //   let hasError = false;

  //   Object.keys(data).map((v) => {
  //     if (v === "order_id" && (data[v] === "open_order" || data[v] === "")) {
  //       return;
  //     }

  //     if (!regex[v]?.test(data[v])) {
  //       setErrors((prevState) => ({ ...prevState, [v]: true }));
  //       hasError = true;
  //     }
  //   });

  //   if (hasError) {
  //     toast.error("Please fill the form correctly", { id: "1" });
  //   } else {
  //     let payload = { ...data };
  //     if (payload.order_id === "open_order" || payload.order_id === "") {
  //       payload.order_id = null;
  //       payload.purchase_id = null;
  //     } else {
  //       payload.purchase_id = payload.order_id;
  //     }

  //     setLoading(true);

  //     supplierService.createpayment(payload).then((res) => {
  //       if (res.responseCode === 201) {
  //         toast.error(res.message, { id: "3" });
  //         setLoading(false);
  //         return;
  //       }

  //       setLoading(false);
  //       toast.success("Income Added Successfully", { id: "2" });
  //       navigate("/incomes");
  //     });
  //   }
  // };

  const handleSubmit = () => {
    let hasError = false;

    Object.keys(data).map((v) => {
      if (v === "order_id" && (data[v] === "open_order" || data[v] === "")) {
        return;
      }

      if (!regex[v]?.test(data[v])) {
        setErrors((prevState) => ({ ...prevState, [v]: true }));
        hasError = true;
      }
    });

    if (hasError) {
      toast.error("Please fill the form correctly", { id: "1" });
    } else {
      let payload = { ...data };

      if (payload.order_id === "open_order" || payload.order_id === "") {
        payload.order_id = null;
        payload.purchase_id = null;
      } else {
        payload.purchase_id = payload.order_id;
      }

      setLoading(true);

      supplierService.createpayment(payload).then((res) => {
        if (res.responseCode === 201) {
          toast.error(res.message, { id: "3" });
          setLoading(false);
          return;
        }

        setLoading(false);
        toast.success("Payment Added Successfully", { id: "2" });
        navigate("/supplierpayments");
      });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };
  return (
    <main className="mx-10 mt-2 p-6 rounded-3xl border border-gray-200 shadow-lg bg-white min-h-[calc(100vh-48px)]">
      <p className="font-bold text-3xl text-secondary text-center mt-10">
        Add Supplier Payment
      </p>

      <div className="mt-10 px-80">
        <div className="grid grid-cols-1 gap-2 md:grid-cols-3 md:gap-4">
          <div>
            <label className={`primary-label`}>Supplier</label>
            <Dropdown
              styling="!col-span-2"
              selected={data.supplier}
              placeholder="Select Supplier"
              onChange={(value) => handleChange(value, "supplier")}
              options={suppliers.map((supplier) => ({
                label: supplier.company,
                value: supplier.id,
              }))}
            />
          </div>

          <div>
            <label className="primary-label">Supplier Orders (Unpaid)</label>
            <Dropdown
              styling="!col-span-2"
              selected={data.order_id}
              placeholder="Select an Order"
              onChange={(value) => handleChange(value, "order_id")}
              options={[
                { label: "Open Order", value: "open_order" },
                ...orders.map((order) => ({
                  label: `Order #${order.id} - Balance: ${order.balance}`,
                  value: order.id,
                })),
              ]}
            />
          </div>
          <div>
            <label className={`primary-label`}>Account</label>
            <Dropdown
              style="!col-span-2"
              selected={data.account}
              placeholder="Select Account"
              onChange={(value) => handleChange(value, "account")}
              options={accounts.map((acc) => ({
                label: `${acc.account_name} - ${acc.account_title}`,
                value: acc.id,
              }))}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-4 md:gap-4">
          <div>
            <label className={`primary-label`}>Amount</label>
            <input
              value={data.amount}
              name="amount"
              type="number"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["amount"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Voucher Type</label>
            <Dropdown
              style="!col-span-2"
              selected={data.voucher}
              placeholder="Select Voucher Type"
              onChange={(value) => handleChange(value, "voucher")}
              options={[
                { label: "CASH PAYMENT VOUCHER", value: "CPV" },
                { label: "BANK PAYMENT VOUCHER", value: "BPV" },
              ]}
            />
          </div>
          <div>
            <label className={`primary-label`}>Date</label>
            <input
              value={data.date}
              type="date"
              name="date"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              placeholder="date"
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["date"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
          <div>
            <label className={`primary-label`}>Note</label>
            <input
              value={data.note}
              name="note"
              onChange={(e) => handleChange(e.target.value, e.target.name)}
              onKeyDown={handleKeyDown}
              className={`primary-input ${
                errors["note"] ? "border-red-600" : "border-gray-300"
              }`}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 gap-2 md:grid-cols-4 md:gap-16">
          <div>
            <label className={`primary-label`}>Payment Method</label>
            <Dropdown
              style="!col-span-2"
              selected={data.method}
              placeholder="Select Payment Method"
              onChange={(value) => handleChange(value, "method")}
              options={[
                { label: "CASH", value: "CASH" },
                { label: "BANK", value: "BANK" },
                { label: "CHEQUE", value: "CHEQUE" },
                { label: "CARD", value: "CARD" },
              ]}
            />
          </div>
        </div>
        <div className="flex items-center justify-center mt-10">
          <button
            onClick={() => handleSubmit()}
            className={`button-primary ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={loading}
          >
            <div className="mr-2 uppercase">Add</div>
            {loading ? <LoadingDots /> : ""}
          </button>
        </div>
      </div>
    </main>
  );
};

export default AddSupplierPayments;
